(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/progress-bar/assets/tracking.js') >= 0) return;  svs.modules.push('/components/numbergames/progress-bar/assets/tracking.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const clean = function () {
  let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.toLowerCase().replaceAll(' ', '');
};
function trackEvent(_ref) {
  let category = _ref.category,
    action = _ref.action,
    label = _ref.label,
    value = _ref.value;
  category = clean(category);
  action = clean(action);
  label = clean(label);
  svs.numbergames.progress_bar.logger.debug('Track', 'category:', category, 'action:', action, 'label:', label);
  svs.components.analytics.trackEvent(_objectSpread(_objectSpread({
    category,
    action
  }, label && {
    opt_label: label
  }), typeof value === 'number' && {
    opt_value: value
  }));
}
function trackStepClick(_ref2) {
  let category = _ref2.category,
    waitTime = _ref2.waitTime,
    stepTime = _ref2.stepTime,
    currentStep = _ref2.currentStep,
    clickedStep = _ref2.clickedStep,
    numberOfSteps = _ref2.numberOfSteps;
  trackEvent({
    category,
    action: 'progress-when-clicked',
    label: "step-".concat(currentStep.stepNr, "-of-").concat(numberOfSteps, "-to-").concat(clickedStep.title)
  });
  if (clickedStep.stepNr === currentStep.stepNr) {
    trackEvent({
      category,
      action: 'click-show-direct',
      label: clickedStep.title
    });
  } else {
    trackEvent({
      category,
      action: 'click-progress-bar',
      label: clickedStep.title
    });
    if (clickedStep.stepNr < currentStep.stepNr) {
      trackEvent({
        category,
        action: 'click-backward',
        label: "to-".concat(clickedStep.title)
      });
    }
    if (waitTime) {
      trackEvent({
        category,
        action: "time-wait-".concat(currentStep.title),
        label: "".concat(waitTime, "s")
      });
    }
    if (stepTime) {
      trackEvent({
        category,
        action: "time-step-".concat(currentStep.title),
        label: "".concat(stepTime, "s")
      });
    }
  }
}
function trackAnimationDone(_ref3) {
  let category = _ref3.category,
    waitTime = _ref3.waitTime,
    stepTime = _ref3.stepTime,
    currentStep = _ref3.currentStep;
  trackEvent({
    category,
    action: "time-wait-".concat(currentStep.title),
    label: "".concat(waitTime, "s")
  });
  trackEvent({
    category,
    action: "time-step-".concat(currentStep.title),
    label: "".concat(stepTime, "s")
  });
  trackEvent({
    category,
    action: 'step-finished',
    label: currentStep.title
  });
}
function trackCorrectionComplete(_ref4) {
  let category = _ref4.category,
    _ref4$winAmount = _ref4.winAmount,
    winAmount = _ref4$winAmount === void 0 ? 0 : _ref4$winAmount,
    numberOfSteps = _ref4.numberOfSteps,
    userInteraction = _ref4.userInteraction;
  let label;
  if (!userInteraction.length || userInteraction.find(ui => ui.clickedStep.stepNr === numberOfSteps)) {
    label = 'result';
  } else if (userInteraction.find(ui => ui.currentStep.stepNr === ui.clickedStep.stepNr)) {
    label = 'show-directly';
  } else {
    label = 'full-experience';
  }
  trackEvent({
    category,
    action: 'correction-complete-qualtrics',
    label,
    value: winAmount
  });
}
Object.assign(svs.numbergames.progress_bar, {
  trackStepClick,
  trackAnimationDone,
  trackCorrectionComplete
});

 })(window);